import { render, staticRenderFns } from "./Submenu.vue?vue&type=template&id=7cbb12c8&"
import script from "./Submenu.vue?vue&type=script&lang=js&"
export * from "./Submenu.vue?vue&type=script&lang=js&"
import style0 from "./Submenu.vue?vue&type=style&index=0&id=7cbb12c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports